<div class="card-container">
  <mat-card fxLayout="column">
    <mat-form-field
      appearance="standard"
      style="padding: 0px 15px 0 15px;"
      fxFlex
    >
      <mat-label>Search</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        (keyup)="applyFilter($event.target.value)"
        placeholder="Type something..."
      />
    </mat-form-field>

    <table
      mat-table
      class="mat-elevation-8 mat-typography"
      [dataSource]="dataSource"
      matSort
    >
      <ng-container matColumnDef="displayName">
        <th *matHeaderCellDef mat-sort-header>Name</th>
        <td *matCellDef="let entity">{{ entity.displayName }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th *matHeaderCellDef mat-sort-header>eMail</th>
        <td *matCellDef="let entity">
          {{ entity.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="roles">
        <th *matHeaderCellDef>Roles</th>
        <td *matCellDef="let entity">
          <mat-checkbox disabled [checked]="entity.hasRole('CUSTOMER')"
            >Customer</mat-checkbox
          >
          &nbsp;&nbsp;&nbsp;&nbsp;
          <mat-checkbox
            [checked]="entity.hasRole('TRAVEL_ADVISOR')"
            (change)="toggleRole(entity, 'TRAVEL_ADVISOR')"
            >Travel Advisor</mat-checkbox
          >
          &nbsp;&nbsp;&nbsp;&nbsp;
          <mat-checkbox disabled [checked]="entity.hasRole('ADMIN')"
            >Admin</mat-checkbox
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="link">
        <th *matHeaderCellDef></th>
        <td *matCellDef="let entity">
          <a
            [routerLink]="['/user', entity.id]"
            *ngIf="entity.hasRole('TRAVEL_ADVISOR')"
            ><mat-icon>arrow_forward</mat-icon></a
          >
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </mat-card>
</div>
